import SystemCheckHtml from '../../templates/systemCheckTemplate.html';
import bell_mp3 from '../../audio/bell.mp3';
import camera from '../../images/camera.svg'
import camera_icon from '../../images/camera_icon.svg'
import microphone from '../../images/microphone.svg';
import net_speed from '../../images/net_speed.svg';
import speaker from '../../images/speaker.svg';
import systemCheck from '../../stylesheets/system_check.css';
import sys_check_steps from '../../images/sys_check_steps.png';
import user_icon from '../../images/user_icon.svg';
import step_error from '../../images/step_error.svg';
import initInternationalization from '../i18nSetup';

var internetSpeedRequired = 5;
var wizard;
var micDevices = [];
var speakerDevices = [];
var cameraDevices = [];
var speakerSwitched = false;
var micSwitched = false;
var cameraSwitched = false;
var audioContext;
var mediaStreamSource = null;
var meter = null;

var systemCheckSuccess;
var systemCheckFail;
var tnDivId;

var videoElement;
var canvas;

var cameraDeviceId;
var speakerDeviceId;
var micDeviceId;

var exitDialog;

let sysCheckError = false;

let errorAlert;

let standaloneCheck= false;

// let uploadTestAPIUrl = "https://upload.rtpaas.pearson.com/uploadFileTest?time=";


export default class SystemCheck {

    initSystemCheckWelcome(systemCheckViewElement, context){
        var that = this;
        that.context = context;
        tnDivId = systemCheckViewElement;
        this.attachListeners();

        //return a promise to RTPaaS
        return new Promise(function(resolve, reject) {
            setTimeout(function (){
                let welcomeHtml =  that.getWelcomeScreen();

                $('#'+tnDivId).html('');
                $('#'+tnDivId).html(welcomeHtml);
                that.replaceWelcomeScreenImages();
                that.initWelcomeScreen();
            },1000);
            systemCheckSuccess = resolve;
            systemCheckFail = reject;
        });
    }

    attachListeners() {
        const events = [
            { name: 'unlockTester', handler: this.unlockTesterHandler.bind(this) }
        ];

        events.forEach(({ name, handler }) => {
            $(document).off(name, handler).on(name, handler);
        });
    }

    unlockTesterHandler() {
        this.enableProceedButton();
    }

    enableProceedButton(){
        $("#testerProceedButton").prop('disabled', false);
        $("#testerProceedButton").removeClass('k-disabled');
    }

    getWaitingScreen(){
        let html = _.template($(SystemCheckHtml).filter("#waitingScreenTemplate").html());
        return html;
    }

    initStandaloneSystemCheckWelcome(systemCheckViewElement){
        var that = this;
        initInternationalization();
        tnDivId = systemCheckViewElement;
        standaloneCheck = true;

        setTimeout(function (){
            let welcomeHtml =  that.getWelcomeScreen();

            $('#'+tnDivId).html('');
            $('#'+tnDivId).html(welcomeHtml);
            that.replaceWelcomeScreenImages();
            that.initWelcomeScreen();
        },1000);

    }

    getWelcomeScreen(){
        let html = _.template($(SystemCheckHtml).filter("#sysCheckWelcomeTemplate").html());
        return html;
    }

    replaceWelcomeScreenImages() {
        var sys_check_stepsImg = document.getElementById('sys_check_steps');
        sys_check_stepsImg.src = sys_check_steps;
    }

    getWizardScreen(){
        let html = _.template($(SystemCheckHtml).filter("#sysCheckWizardTemplate").html());
        return html;
    }

    replaceWizardScreenImages() {
        var cameraImg = document.getElementById('cameraImgId');
        cameraImg.src = camera;

        var microphoneImg = document.getElementById('microphoneImgId');
        microphoneImg.src = microphone;

        var net_speedImg = document.getElementById('netSpeedImgId');
        net_speedImg.src = net_speed;

        var speakerImg = document.getElementById('speakerImgId');
        speakerImg.src = speaker;
    }

    getCompleteScreen(){
        let html = _.template($(SystemCheckHtml).filter("#sysCheckCompleteTemplate").html());
        return html;
    }

    getStandaloneCompleteScreen(){
        let html = _.template($(SystemCheckHtml).filter("#standaloneSysCheckCompleteTemplate").html());
        return html;
    }

    getStandaloneCancelScreen(){
        let html = _.template($(SystemCheckHtml).filter("#standaloneSysCheckCancelTemplate").html());
        return html;
    }

    replaceCompleteScreenImages() {
        var camera_iconImg = document.getElementById('camera_icon');
        camera_iconImg.src = camera_icon;

        var user_iconImg = document.getElementById('checkCompleteStudentImage');
        user_iconImg.src = user_icon;
    }

    initKendoWizard() {
        let that = this;
        let cancelButton = rtp_i18next.t('systemCheck:cancelButton');
        wizard = $k("#wizard").kendoWizard({
            messages: {
                step: rtp_i18next.t('systemCheck:step'),
                of: rtp_i18next.t('systemCheck:of')
            },
            label: false,
            reset: false,
            stepper: {
                linear: false
            },
            steps: [{
                title: rtp_i18next.t('systemCheck:internet'),
                errorIcon: 'none',
                buttons: [{
                    name: 'Cancel',
                    text: rtp_i18next.t('systemCheck:cancelButton'),
                    click: function(e){
                        that.openExitDialogConfirm(e);
                    }
                }, {
                    name: 'Next',
                    text: rtp_i18next.t('systemCheck:nextButton'),
                    enabled: false,
                    primary: false
                }]
            }, {
                title: rtp_i18next.t('systemCheck:microphone'),
                errorIcon: "none",
                buttons: [{
                    name: 'Cancel',
                    text: rtp_i18next.t('systemCheck:cancelButton'),
                    click: function(e){
                        that.openExitDialogConfirm(e);
                    }
                }, {
                    name: 'Next',
                    text: rtp_i18next.t('systemCheck:nextButton'),
                    enabled: false,
                    primary: false
                }]
            }, {
                title: rtp_i18next.t('systemCheck:speakers'),
                buttons: [{
                    name: 'Cancel',
                    text: rtp_i18next.t('systemCheck:cancelButton'),
                    click: function(e){
                        that.openExitDialogConfirm(e);
                    }
                }, {
                    name: 'Next',
                    text: rtp_i18next.t('systemCheck:nextButton'),
                    enabled: false,
                    primary: false
                }]
            }, {
                title: rtp_i18next.t('systemCheck:camera'),
                buttons: [{
                    name: 'Cancel',
                    text: rtp_i18next.t('systemCheck:cancelButton'),
                    click: function(e){
                        that.openExitDialogConfirm(e);
                    }
                }, {
                    name: 'Next',
                    text: rtp_i18next.t('systemCheck:nextButton'),
                    enabled: false,
                    primary: false,
                    click: function(){
                        if( standaloneCheck ){
                            that.standaloneInitCompleteScreen()
                        }else {
                            that.initCompleteScreen();
                        }
                    }
                }]
            }],
            activate: function (e) {
            },
            select: function (e) {
                that.onStepLoad(e);
            },

        }).data("kendoWizard");
        this.toggleWizardSteps();
    }

    onStepLoad(e) {
        this.RTPaaSStopSound();//make sure the sound isn't still playing if we switch steps
        if (e.step.options.index === 1) {
            this.getMicroPhoneList();
        } else if( e.step.options.index === 2 ){
            this.getSpeakerList();
        } else if( e.step.options.index === 3 ){
            this.getCameraList();
        }
    }

    updateFailureStepIcon() {
        let activeStep =$(wizard.wrapper).find('.k-step')[wizard.activeStep().options.index];
        let activeStepIndicator = $(activeStep).find(".k-step-indicator");
        $(activeStepIndicator).addClass('k-step-indicator-warning');
        $(activeStepIndicator).removeClass('k-step-indicator');

        let indicatorTxt = $(activeStepIndicator).find(".k-step-indicator-text");
        indicatorTxt.html('<img id="stepError" style="padding-top: 5px;padding-left: 5px;vertical-align: middle;"/>');
        let step_errorImg = document.getElementById('stepError');
        step_errorImg.src = step_error;
    }

    micTestSuccess(){
        let devId = $("#micListSelect").val();
        micDeviceId = devId;
        sysCheckError = false;

        this.stopMicTest();
        this.hideElement("MicFail-rtpsys");
        this.showElement("micSuccess-rtpsys");
        this.uncheckMicRadio();
        this.enableNextStep();
    }

    micTestFailed( micNotFound ){
        // mic test failed, disable next button and all top next step icons
        this.toggleWizardSteps();
        sysCheckError = true;
        if( micNotFound ){
            errorAlert = this.buildRTPSystemCheckError("micNotAvailable");
        }else{
            errorAlert = this.buildRTPSystemCheckError("micFailed");
        }
        this.stopMicTest();
        this.hideElement("micSuccess-rtpsys");
        $('#micFailMessage').html('');
        $('#micFailMessage').html(errorAlert.failureMsg);

        this.resetSpeakerCheck();
        this.resetCameraCheck();

        this.showElement("MicFail-rtpsys");
        this.uncheckMicRadio();
        this.updateFailureStepIcon();
    }

    uncheckMicRadio() {
        $('#mic_confirm-rtpsys input[name=MicYesRadio]').prop('checked', false);
        $('#mic_confirm-rtpsys input[name=MicNoRadio]').prop('checked', false);
    }

    uncheckSpeakerRadio() {
        $('#speaker_confirm-rtpsys input[name=SpeakerYesRadio]').prop('checked', false);
        $('#speaker_confirm-rtpsys input[name=SpeakerNoRadio]').prop('checked', false);
    }

    uncheckCameraRadio() {
        $('#cameraConfirm input[name=CameraYesRadio]').prop('checked', false);
        $('#cameraConfirm input[name=CameraNoRadio]').prop('checked', false);
    }

    speakerTestSuccess() {
        let devId = $("#speakerListSelect").val();
        speakerDeviceId= devId;
        sysCheckError = false;

        this.RTPaaSStopSound();
        this.hideElement("SpeakerFail-rtpsys");
        this.showElement("SpeakerSuccess-rtpsys");
        this.uncheckSpeakerRadio();
        this.enableNextStep();
    }
    speakerTestFailed( speakerNotFound ){
        // speaker test failed, disable next button and all top next step icons
        this.toggleWizardSteps();
        sysCheckError = true;
        if( speakerNotFound ){
            errorAlert = this.buildRTPSystemCheckError("speakerNotAvailable");
        }
        else{
            errorAlert = this.buildRTPSystemCheckError("selectedSpeakerNotReady");
        }
        this.RTPaaSStopSound();
        $('#speakerFailMessage').html(errorAlert.failureMsg);
        this.hideElement("SpeakerSuccess-rtpsys");
        this.showElement("SpeakerFail-rtpsys");

        this.uncheckSpeakerRadio();
        this.updateFailureStepIcon();
    }
    cameraTestSuccess(){
        let devId = $("#cameraListSelect").val();
        cameraDeviceId = devId;
        sysCheckError = false;
        this.captureImage();
        this.RTPaaSStopVideo();
        this.hideElement("CameraFail");
        this.showElement("CameraSuccess");
        $(this).prop('checked', false);
        this.uncheckCameraRadio();
        this.enableNextStep();
    }
    cameraTestFailed( cameraErrorCode ){
        // camera test failed, disable next button and all top next step icons
        this.toggleWizardSteps();
        sysCheckError = true;
        errorAlert = this.buildRTPSystemCheckError(cameraErrorCode);
        this.RTPaaSStopVideo();
        $('#cameraFailMessage').html(errorAlert.failureMsg);
        this.hideElement("CameraSuccess");
        this.showElement("CameraFail");
        $(this).prop('checked', false);
        this.uncheckCameraRadio();
        this.updateFailureStepIcon();
    }

    async getMicroPhoneList() {
        let that = this;
        that.disableMainDiv(1);
        this.hideElement("MicFail-rtpsys");
        let permissionError = false;
        await  navigator.mediaDevices.getUserMedia({ video: false, audio: true })
            .then(stream => {
            })
            .catch(e => {
                console.error("e: ", e);
                permissionError = true;

                this.micTestFailed(true);
                this.enableMainDiv();
                // clear the list of Microphones if exists
                if( $k("#micListSelect") && $k("#micListSelect").data("kendoDropDownList")){
                    let ddl = $k("#micListSelect").data("kendoDropDownList");
                    ddl.dataSource.data([]);
                }
                return;
            });

        // even after permission error, enumerateDevices is returning blank device list, so this permissionError check
        if (!permissionError) {
            // show micListDiv, may have got hidden in last getMicroPhoneList call
            $("#micListDiv .deviceListDiv-rtpsys").css("display", "block");
            let deviceList = await navigator.mediaDevices.enumerateDevices();
            // clear the micDevices if any
            micDevices = [];
            for (const _device of deviceList) {
                let device = {};
                if(_device.deviceId === "default" || _device.deviceId === "communications"){
                    continue;
                }
                for (let prop in _device) {
                    device[prop] = _device[prop];
                }
                if(device.kind === 'audioinput' ){
                    micDevices.push(device);
                }
            }
            if(micDevices.length > 0) {
                let micSelect = [];
                for (let d of micDevices) {
                    if (d.label) {
                        let d1={text: d.label, value: d.deviceId};
                        micSelect.push(d1);
                    } else {
                        let d2={text: "Microphone " + micSelect.length + 1, value: d.deviceId};
                        micSelect.push(d2);
                    }
                }
                $k("#micListSelect").kendoDropDownList({
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: micSelect,
                    index: 0,
                    change: function(){
                        that.microphoneChanged();
                    }
                });

            this.handleDeviceListDropdown( micSelect, "micListSelect");

            }
        } else {
            // No mic's available to test hide micListDiv
            $("#micListDiv .deviceListDiv-rtpsys").css("display", "none");
        }
        that.enableMainDiv();
    }

    async getSpeakerList() {
        let that = this;
        that.disableMainDiv(2);
        this.hideElement("SpeakerFail-rtpsys");
        let permissionError = false;
        await  navigator.mediaDevices.getUserMedia({ video: false, audio: true })
            .then(stream => {
            })
            .catch(e => {
                console.error("e: ", e);
                permissionError = true;
                that.speakerTestFailed(true);
                that.enableMainDiv();
                // clear the list of Speakers if exists
                if( $k("#speakerListSelect") && $k("#speakerListSelect").data("kendoDropDownList")){
                    let ddl = $k("#speakerListSelect").data("kendoDropDownList");
                    ddl.dataSource.data([]);
                }
                return;
            });

        // even after permission error, enumerateDevices is returning blank device list, so this permissionError check
        if (!permissionError) {
            // show speakerListSelect, may have got hidden in last getSpeakerList call
            $("#speakerListDiv .deviceListDiv-rtpsys").css("display", "block");
            let deviceList = await navigator.mediaDevices.enumerateDevices();

            // clear the speakerDevices if any
            speakerDevices = [];
            for (const _device of deviceList) {
                var device = {};
                if(_device.deviceId === "default" || _device.deviceId === "communications"){
                    continue;
                }
                for (let prop in _device) {
                    device[prop] = _device[prop];
                }
                if(device.kind === 'audiooutput' ){
                    speakerDevices.push(device);
                }
            }

            if (speakerDevices.length > 0) {
                this.showElement("speakerListSelect");
                this.hideElement("speakerNoSpeakerDiv");

                let spSelect = [];
                for (let d of speakerDevices) {
                    if (d.label) {
                        let d1={text: d.label, value: d.deviceId};
                        spSelect.push(d1);
                    } else {
                        let d2={text: "speaker " + spSelect.length + 1, value: d.deviceId};
                        spSelect.push(d2);
                    }
                }
                $k("#speakerListSelect").kendoDropDownList({
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: spSelect,
                    index: 0,
                    change: function(){
                        that.speakerChanged();
                    }
                });

            this.handleDeviceListDropdown( spSelect, "speakerListSelect");

            } else {
                this.hideElement("speakerListSelect");
                this.showElement("speakerNoSpeakerDiv");
            }
        }else{
            // No speaker's available to test hide micListDiv
            $("#speakerListDiv .deviceListDiv-rtpsys").css("display", "none");
        }
        that.enableMainDiv();
    }

    async getCameraList() {
        let that = this;
        that.disableMainDiv(3);
        this.hideElement("CameraFail");
        let permissionError = false;
        await  navigator.mediaDevices.getUserMedia({ video: true, audio: false })
            .then(stream => {
            })
            .catch(e => {
                console.error("e: ", e);
                permissionError = true;
                that.cameraTestFailed("cameraNotAvailable");
                that.enableMainDiv();
                // clear the list of Cameras if exists
                if( $k("#cameraListSelect") && $k("#cameraListSelect").data("kendoDropDownList")){
                    let ddl = $k("#cameraListSelect").data("kendoDropDownList");
                    ddl.dataSource.data([]);
                }
                return;
            });

        // even after permission error, enumerateDevices is returning blank device list, so this permissionError check
        if (!permissionError) {
            // show cameraListSelect, may have got hidden in last getCameraList call
            $("#cameraListDiv .deviceListDiv-rtpsys").css("display", "block");
            let deviceList = await navigator.mediaDevices.enumerateDevices();
            // clear the cameraDevices if any
            cameraDevices = [];
            for (const _device of deviceList) {
                let device = {};
                if(_device.deviceId === "default" || _device.deviceId === "communications"){
                    continue;
                }
                for (let prop in _device) {
                    device[prop] = _device[prop];
                }
                if(device.kind === 'videoinput' ){
                    if(this.isIpad()) {
                        if(!(device.label.toLowerCase().indexOf('back') >= 0|| device.label.toLowerCase().indexOf('trasera') >= 0)){
                            cameraDevices.push(device);
                        }
                    }else{
                        cameraDevices.push(device);
                    }
                }
            }
            if(cameraDevices.length > 0) {
                let camSelect = [];
                for (let d of cameraDevices) {
                    if (d.label) {
                        let d1={text: d.label, value: d.deviceId};
                        camSelect.push(d1);
                    } else {
                        let d2={text: "Camera " + camSelect.length + 1, value: d.deviceId};
                        camSelect.push(d2);
                    }
                }

                $k("#cameraListSelect").kendoDropDownList({
                    dataTextField: "text",
                    dataValueField: "value",
                    dataSource: camSelect,
                    index: 0,
                    change: function(){
                        that.cameraChanged();
                    }
                });

            this.handleDeviceListDropdown( camSelect, "cameraListSelect");

            }
        }else{
            // No camera's available to test hide cameraListSelect
            $("#cameraListDiv .deviceListDiv-rtpsys").css("display", "none");
        }
        that.enableMainDiv();
    }

    handleDeviceListDropdown( deviceList, listId ){
        let dropdownlist = $k("#" + listId).data("kendoDropDownList");
        let dialogWrapper = dropdownlist.wrapper;
        if( deviceList.length == 1 ) {
            //only one device found, make list readonly to disable selection, and hide dropdown
            dropdownlist.readonly();
            $(dialogWrapper).find('.k-input-button').css("display", "none");
        }else{
            //more than one device found, enable selection, and show dropdown
            dropdownlist.readonly(false);
            $(dialogWrapper).find('.k-input-button').css( "display", "block" );
        }
    }

    disableMainDiv(cnt){

        $(".systemCheckDiv-rtpsys").each(function(i) {
            var $div = $(this);
            if(cnt === i){
                $div.append('<div id="dropDownloader-rtpsys" class="rtpSystemCheck-Center"></div>');
            }
        });
    }
    enableMainDiv(){
        $("#dropDownloader-rtpsys").remove();
    }

    resetMicrophoneCheck() {
        this.hideElement("micSuccess-rtpsys");
        this.hideElement("MicFail-rtpsys");
        this.hideElement('mic_confirm-rtpsys');
        this.hideElement('u22-rtpsys');
    }

    microphoneChanged(){
        let value = $("#micListSelect").val();
        micSwitched = true;
        this.resetMicrophoneCheck();
        this.toggleWizardSteps();
    }

    resetSpeakerCheck() {
        this.hideElement("SpeakerSuccess-rtpsys");
        this.hideElement("SpeakerFail-rtpsys");
        this.RTPaaSStopSound();
    }

    speakerChanged(){
        let value = $("#speakerListSelect").val();
        speakerSwitched = true;
        this.resetSpeakerCheck();
        this.toggleWizardSteps();
    }

    resetCameraCheck() {
        this.hideElement("cameraConfirm");
        this.hideElement("CameraSuccess");
        this.hideElement("CameraFail");
    }

    cameraChanged(){
        let value = $("#cameraListSelect").val();
        cameraSwitched = true;
        this.resetCameraCheck();
        this.toggleWizardSteps();
    }

    isIpad(){
        return navigator.userAgent.match(/iPad/i) != null || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1;

    }

    /*   Camera test START */
    RTPaaSStartVideo(){
        this.resetCameraCheck();
        let videoDiv = document.getElementById("video_div");
        if (videoElement) {
            this.RTPaaSStopVideo();
        }
        videoDiv.innerHTML ="";
        videoElement = document.createElement('video');
        videoElement.id="videoTest";
        videoElement.style.cssText = "width: 192px;height: 102px;";
        videoElement.setAttribute("id", "videoTest");
        let constraints = {
            video: true, audio: false
        };
        let devId = null;
        if (cameraSwitched) {
            devId = $("#cameraListSelect").val();
            if (devId) {
                constraints = { video: { deviceId: devId }, audio: false };
            }
        }
        navigator.mediaDevices
            .getUserMedia( constraints )
            .then((stream) => {
                var facingMode = stream?.getTracks()[0]?.getCapabilities()?.facingMode;
                if(facingMode && facingMode.length > 0){
                    if(facingMode.indexOf("environment") > -1){
                        this.resetCameraCheck();
                        this.cameraTestFailed("rearCameraNotAllowed");
                        return;
                    }
                }
                videoElement.srcObject = stream;
                videoElement.play();
                this.showElement("cameraConfirm");
            })
            .catch((err) => {
                console.error(`An error occurred: ${err}`);
                this.resetCameraCheck();
                this.cameraTestFailed("cameraNotAvailable");

            });

        videoDiv.appendChild(videoElement);
    }

    RTPaaSStopVideo() {
        this.hideElement("cameraConfirm");
        let videoElement = document.getElementById("videoTest");
        if (videoElement) {
            videoElement.pause();
            const videoStream = videoElement.srcObject;
            if (videoStream) {
                const camTracks = videoStream.getTracks();
                if (camTracks) {
                    camTracks.forEach(track => {
                        track.stop();
                        videoElement.srcObject.removeTrack(track);
                    });
                    videoElement.srcObject = null;
                }
            }
            videoElement.remove();
        }
    }
    /*   Camera test END */

    /*   Speakers test START */

    RTPaaSPlaySound(){
        this.RTPaaSStopSound();
        //remove previously started audio element if any
        this.stopSpeakerAudioPlaying()

        const audioElement = document.createElement('audio');

        audioElement.id="audioTest";
        audioElement.setAttribute("id", "audioTest");
        audioElement.controls = false;
        audioElement.autoplay = false;
        audioElement.loop = true;
        audioElement.src = bell_mp3;

        let devId = $("#speakerListSelect").val();
        if (devId) {
            audioElement.setSinkId(devId);
            document.body.appendChild(audioElement);
            this.showElement("speaker_confirm-rtpsys");
            audioElement.play();
        } else {
            document.body.appendChild(audioElement);
            this.showElement("speaker_confirm-rtpsys");
            audioElement.play();
            return;
        }
    }

    RTPaaSStopSound() {
        this.stopSpeakerAudioPlaying();
        let mic1Element = document.getElementById("speaker_confirm-rtpsys");
        if (mic1Element) {
            mic1Element.style.cssText = "display:none";
        }
    }

    stopSpeakerAudioPlaying() {
        let audioElement = document.getElementById("audioTest");
        if (audioElement) {
            audioElement.remove();
        }
    }
    /*   Speakers test END */


    /*   Mic test START */

    beginMicTest() {
        let that = this;
        this.stopMicTest();
        this.getMicroPhoneList();

        var dropdownlist = $k("#micListSelect").data("kendoDropDownList");
        if (dropdownlist) {
            dropdownlist.enable(false);
        }

        this.resetMicrophoneCheck();
        this.showElement("u22-rtpsys");

        $("#micListDiv input[type='radio']").on('change', function() {
            let which = $('#micListDiv input[name=MicRadio]:checked').val();
            if( which === 'Yes'){
                that.micTestSuccess();
            } else if( which === 'No'){
                that.micTestFailed();
            }
        });

        let constraints = {
            audio:true
        };
        let devId = $("#micListSelect").val();
        if (devId) {
            constraints = {
                audio: {
                    deviceId: {
                        exact: devId,
                    },
                },
            };
        }
        audioContext = new (window.AudioContext || window.webkitAudioContext)();
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
            navigator.mediaDevices.getUserMedia(constraints).then((stream) => {
                that.meter = that.createAudioMeter(audioContext,that);
                that.mediaStreamSource = audioContext.createMediaStreamSource(stream);
                that.mediaStreamSource.connect(that.meter);
                that.microphoneTestStream = stream;
                this.showElement("mic_confirm-rtpsys");
            }).catch(e => {
                console.error("e: ", e);
                that.micTestFailed(true);
                const microphone = navigator.permissions.query({ name: 'microphone' });
            });
        }

    }

    stopMicTest() {
        this.hideElement("u22-rtpsys");
        this.hideElement("mic_u145-rtpsys");
        this.hideElement("mic_confirm-rtpsys");

        if (this.meter) {
            this.meter.shutdown();
            this.showVolumeMeter(0);
            this.mediaStreamSource.mediaStream.getTracks().forEach((track) => track.stop());
            this.mediaStreamSource.disconnect(this.meter);
        }
        audioContext = null;
        this.mediaStreamSource = null;
        this.meter = null;

        let dropdownlist = $k("#micListSelect").data("kendoDropDownList");
        if( dropdownlist ) {
            dropdownlist.enable(true);
        }
    }

    createAudioMeter(audioContext, that, clipLevel, averaging, clipLag) {
        const processor = audioContext.createScriptProcessor(512);// bufferSize is 512  , should be power of 2
        processor.onaudioprocess = function(e){
            that.volumeAudioProcess(e,that);
        };
        processor.clipping = false;
        processor.lastClip = 0;
        processor.volume = 0;
        processor.clipLevel = clipLevel || 0.98;
        processor.averaging = averaging || 0.95;
        processor.clipLag = clipLag || 750;

        // this will have no effect, since we don't copy the input to the output,
        // but works around a current Chrome bug.
        processor.connect(audioContext.destination);

        processor.checkClipping = function () {
            if (!this.clipping) {
                return false;
            }
            if ((this.lastClip + this.clipLag) < window.performance.now()) {
                this.clipping = false;
            }
            return this.clipping;
        };

        processor.shutdown = function () {
            this.disconnect();
            this.onaudioprocess = null;
        };

        return processor;
    }

    volumeAudioProcess(event,that) {
        const buf = event.inputBuffer.getChannelData(0);
        const bufLength = buf.length;
        let sum = 0;
        let x;

        // Do a root-mean-square on the samples: sum up the squares...
        for (let i = 0; i < bufLength; i++) {
            x = buf[i];
            if (Math.abs(x) >= this.clipLevel) {
                this.clipping = true;
                this.lastClip = window.performance.now();
            }
            sum += x * x;
        }

        // ... then take the square root of the sum.
        const rms = Math.sqrt(sum / bufLength);

        // Now smooth this out with the averaging factor applied
        // to the previous sample - take the max here because we
        // want "fast attack, slow release."
        event.currentTarget.volume
            = Math.max(rms, event.currentTarget.volume
            * event.currentTarget.averaging);
        let volumePercent = event.currentTarget.volume * 100;

        that.showVolumeMeter(volumePercent);

    }

    showVolumeMeter(vol) {
        let greenBoxes = Array.from(document.getElementsByClassName('green-box-div-rtpsys'));
        let range = greenBoxes.slice(0, Math.round(vol));

        for (let i = 0; i < greenBoxes.length; i++) {
            //remove all existing backgroundColor
            greenBoxes[i].style.backgroundColor = "";
        }

        for (let i = 0; i < range.length; i++) {
            //add backgroundColor to display volume level
            range[i].style.backgroundColor = `#95f204`;
        }
    }

    /*   Mic test END */

    hideElement(elemId){
        const elemHide = document.getElementById(elemId);
        if(elemHide){
            elemHide.style.cssText = "display:none";
        }
    }
    showElement(elemId){
        const elemShow = document.getElementById(elemId);
        if(elemShow){
            elemShow.style.cssText = "display:block";
        }
    }
    /*   Internet Speed test START */
    async RTPaaSStartNetworkTest() {
        this.hideElement('internetSuccess');
        this.hideElement('internetFail-rtpsys');
        this.showElement('u145-rtpsys');
        this.showElement('speedProgress-rtpsys');

        let speedInMbps = 0;
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            this.networkTestSuccess();
            // speedInMbps = await this.checkUploadSpeedWithAPI();
            // if (!speedInMbps || speedInMbps <= 0) {
            //     this.networkTestNotAvailable();
            // } else if (speedInMbps >= internetSpeedRequired) {
            //     this.networkTestSuccess();
            // } else {
            //     this.networkTestSlow();
            // }
        } catch(e) {
            console.error("RTPaaSStartNetworkTest() ERROR "+e);
            this.networkTestNotAvailable();
            wizard.enableStep(1, false);
            wizard.enableStep(2, false);
            wizard.enableStep(3, false);
        }
    }
    networkTestSuccess(){
        this.showElement('internetSuccess');
        this.hideElement('internetFail-rtpsys');
        this.hideElement('u145-rtpsys');
        this.hideElement('speedProgress-rtpsys');
        sysCheckError = false;
        this.enableNextStep();
    }

    networkTestSlow() {
        this.networkTestFailed('netSpeedSlow');
    }

    networkTestNotAvailable() {
        this.networkTestFailed('netSpeedFailed');
    }

    networkTestFailed(networkErrorCode) {
        this.hideElement('internetSuccess');
        this.showElement('internetFail-rtpsys');
        this.hideElement('u145-rtpsys');
        this.updateFailureStepIcon();
        this.hideElement('speedProgress-rtpsys');
        sysCheckError = true;
        let networkSpeedResultsElement = document.getElementById("networkSpeedResults-rtpsys");

        errorAlert = this.buildRTPSystemCheckError(networkErrorCode);
        if (networkSpeedResultsElement) {
            networkSpeedResultsElement.innerHTML = errorAlert.failureMsg;
        }
    }

    calculateSpeed(sizeInBytes, timeDuration) {
        const sizeInBits = sizeInBytes * 8;


        return ((sizeInBits / timeDuration).toFixed(2) / 1024) / 1024;



    }

    initSystemCheck() {
        let that = this;
        $(document).ready(function () {
            $("#SpeedTestbutton").click(function (event) {
                that.toggleWizardSteps();
                that.RTPaaSStartNetworkTest();
            });
            $("#MicTestbutton").click(function (event) {
                that.toggleWizardSteps();
                that.beginMicTest();
            });

            $("#mic_confirm-rtpsys input[type='radio']").on('change', function () {
                let which = $('#mic_confirm-rtpsys input[name=MicYesRadio]:checked');
                if (which && which.length > 0) {
                    that.micTestSuccess();
                } else {
                    that.micTestFailed();
                }
            });

            $("#speaker_confirm-rtpsys input[type='radio']").on('change', function () {
                let which = $('#speaker_confirm-rtpsys input[name=SpeakerYesRadio]:checked');
                if (which && which.length > 0) {
                    that.speakerTestSuccess();
                } else {
                    that.speakerTestFailed();
                }
            });

            $("#cameraConfirm input[type='radio']").on('change', function () {
                let which = $('#cameraConfirm input[name=CameraYesRadio]:checked');
                if (which && which.length > 0) {
                    that.cameraTestSuccess();
                } else {
                    that.cameraTestFailed("selectedCameraNotReady");
                }
            });

            $("#SpeakerTestButton").click(function (event) {
                that.toggleWizardSteps();
                that.RTPaaSPlaySound();
            });

            $("#CameraTestbutton").click(function (event) {
                that.toggleWizardSteps();
                that.RTPaaSStartVideo();
            });

            wizard.select(0);
        });
    }
    /*   Internet Speed test END */

    initWelcomeScreen() {
        let that = this;
        $k("#nextButton").kendoButton({
            themeColor: "primary",
            size:'Large',
            click:function (){
                that.goSystemCheck();
            }
        });
        $k("#cancelButton").kendoButton({
            size:'Large',
            click:function(){
                //that.callTNErrorCallback("system check not completed");
                that.openExitDialogConfirm();
            }
        });
        if( standaloneCheck ) {
            this.initStandaloneExitDialog();

        }else{
            this.initExitDialog();
        }
    }

    initExitDialog(){
        let that = this;
        exitDialog = $k('#exitMainId');
        exitDialog.kendoDialog({
            width: "505x",
            height: "242px",
            className:"exitDialogClass-rtpsys",
            title: rtp_i18next.t('systemCheck:exitDialogTitle'),
            closable: true,
            modal: true,
            visible: false,
            content: "<p class='exitDialogText-rtpsys'>" + rtp_i18next.t('systemCheck:exitDialogText') + "<p>",
            actions: [
                { text: rtp_i18next.t('systemCheck:exitDialogClose'), primary: false,cssClass:"k-button k-button-md k-rounded-md k-button-solid k-button-solid-base exitDialogButtons-rtpsys" },
                { text: rtp_i18next.t('systemCheck:exitDialogExit'), primary: true,cssClass:"k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button-solid-primary exitDialogButtons-rtpsys",
                    action: function(e){
                        that.exitDialogExitClick(e);
                    } }
            ],
            close: function (e){
                that.exitDialogClose(e);
            }
        });
        let dialog = $k("#exitMainId").data("kendoDialog");
        let dialogWrapper = dialog.wrapper;

        dialogWrapper.addClass("exitDialogClass-rtpsys");
    }

    initStandaloneExitDialog(){
        let that = this;
        exitDialog = $k('#exitMainId');
        exitDialog.kendoDialog({
            width: "505x",
            height: "236px",
            className:"exitDialogClass-rtpsys",
            title: rtp_i18next.t('systemCheck:standaloneExitDialogTitle'),
            closable: true,
            modal: true,
            visible: false,
            content: "<br><p class='exitDialogText-rtpsys'>" + rtp_i18next.t('systemCheck:standaloneExitDialogText') + "<p>",
            actions: [
                { text: rtp_i18next.t('systemCheck:standaloneExitDialogClose'), primary: false,cssClass:"k-button k-button-md k-rounded-md k-button-solid k-button-solid-base exitDialogButtons-rtpsys" },
                { text: rtp_i18next.t('systemCheck:standaloneExitDialogExit'), primary: true,cssClass:"k-button k-button-md k-rounded-md k-button-solid k-button-solid-base k-button-solid-primary exitDialogButtons-rtpsys",
                    action: function(e){
                        that.standaloneDialogExitClick(e);
                    } }
            ],
            close: function (e){
                that.exitDialogClose(e);
            }
        });
        let dialog = $k("#exitMainId").data("kendoDialog");
        let dialogWrapper = dialog.wrapper;

        dialogWrapper.addClass("exitDialogClass-rtpsys");
    }

    openExitDialogConfirm(){
        exitDialog.data("kendoDialog").open();
    }

    exitDialogClose(e){
    }

    exitDialogExitClick() {
        this.RTPaaSStopSound();

        // default system check error
        let message= this.buildRTPSystemCheckError("systemCheckExitedError");

        if( sysCheckError ){
            // if system check error, get the errorAlert
            message = errorAlert;
        }
        this.callTNErrorCallback( message );
    }

    standaloneDialogExitClick(){
        this.RTPaaSStopSound();
        let compHtml =  this.getStandaloneCancelScreen();
        $('#'+tnDivId).html('');
        $('#'+tnDivId).html(compHtml);
    }

    exitDialogCancelClick(){
    }

    goSystemCheck(){
        document.querySelector('#welcomeMainDiv').remove();
        let wizardHtml =  this.getWizardScreen();

        $('#'+tnDivId).html('');
        $('#'+tnDivId).html(wizardHtml);

        this.replaceWizardScreenImages();

        this.initKendoWizard();
        this.initSystemCheck();
    }
    goBackToWelcome(){
        document.querySelector('#WizardMainDiv-rtpsys').remove();

        let wizardHtml =  this.getWelcomeScreen();
        $('body').append(wizardHtml);
        document.querySelector('#welcomeMainDiv').style.cssText = 'display: block;';
        this.replaceWelcomeScreenImages();

        this.initWelcomeScreen();
    }

    callTNErrorCallback(failureObj){
        systemCheckFail(failureObj);
    }
    callTNSuccessCallback(){
        var successObj = {
            successMsg: "System Check Success",
            micId: this.getMicDeviceId(),
            speakerId: this.getSpeakerDeviceId(),
            cameraId: this.getCameraDeviceId()
        };
        systemCheckSuccess(successObj);
    }

    initCompleteScreen() {
        document.querySelector('#WizardMainDiv-rtpsys').remove();
        let compHtml =  this.getCompleteScreen();

        $('#'+tnDivId).html('');
        $('#'+tnDivId).html(compHtml);

        this.replaceCompleteScreenImages();

        let that = this;
        $k("#nextButton").kendoButton({
            themeColor: "primary",
            size:'Large',
            click: function () {
                if(that.context.groupCallFirst && that.context.isLocked === true){
                    that.initWaitingScreen();
                }else {
                    that.startTest();
                }
            }
        });

        let imgData = sessionStorage.getItem('StudentImage');
        if(imgData) {
            $("#checkCompleteStudentImage").attr('src', imgData);
        }

    }

    initWaitingScreen() {
        document.querySelector('.chkCompDiv_1-rtpsys').remove();
        $(`#${tnDivId}`).html(this.getWaitingScreen());

        $("#testerProceedButton").off('click').on('click', () => {
            this.startTest();
        });

    }

    standaloneInitCompleteScreen() {
        document.querySelector('#WizardMainDiv-rtpsys').remove();
        let compHtml =  this.getStandaloneCompleteScreen();

        $('#'+tnDivId).html('');
        $('#'+tnDivId).html(compHtml);
    }

    startTest(){
        document.querySelector('#'+tnDivId).innerHTML = "";
        this.callTNSuccessCallback();
    }

    captureImage() {
        canvas = document.createElement("canvas");
        const mimeType = typeof outputFormat !== 'undefined' && outputFormat === 'png' ? 'image/png' : 'image/jpeg';
        canvas.width = 480;
        canvas.height = 360;

        canvas.getContext("2d").clearRect(0, 0, canvas.width, canvas.height);
        canvas.getContext("2d").drawImage(
            videoElement,
            0,
            0,
            canvas.width,
            canvas.height
        );

        const newImageData = canvas.toDataURL(mimeType, 60 / 100);
        sessionStorage.setItem('StudentImage', newImageData);
    }

    toggleWizardSteps() {
        let that = this;
        //Enable all steps up to the current step.  Disable anything after that.
        let nextStepNumber = wizard.currentStep.options.index + 1;
        let enabledSteps =  [...wizard.steps()];
        let disabledSteps = enabledSteps.splice(nextStepNumber);
        enabledSteps.forEach(function(step) {
            that.enableStep(step);
        });
        disabledSteps.forEach(function(step) {
            that.disableStep(step);
        });
        this.disableNextButton(wizard.activeStep());
        this.resetSuccessFailMessages();
    }

    resetSuccessFailMessages() {
        //reset any success or fail messages after our current step
        let resetFunctions = [];
        resetFunctions.push(new Function());//we won't ever need to clear the camera messages, so we can invoke an empty function
        resetFunctions.push(this.resetMicrophoneCheck.bind(this));
        resetFunctions.push(this.resetSpeakerCheck.bind(this));
        resetFunctions.push(this.resetCameraCheck.bind(this));
        let resetFunctionsToCall = [...resetFunctions].splice(wizard.currentStep.options.index);
        resetFunctionsToCall.forEach(function(resetFunction) {
            resetFunction();
        });
    }

    enableNextStep() {
        let stepNumber = wizard.currentStep.options.index;
        let currentStep = wizard.steps()[stepNumber];
        //enable the current step's "next" button
        this.enableNextButton(currentStep);
        //enable the next step's wizard button
        if(stepNumber + 1 >= wizard.steps().length) {
            return;
        }
        let nextStep = wizard.steps()[stepNumber + 1];
        this.enableStep(nextStep);
    }

    enableStep(step) {
        wizard.enableStep(step.options.index, true);
    }

    disableStep(step) {
        wizard.enableStep(step.options.index, false);
        this.disableNextButton(step);
    }

    enableNextButton(step) {
        if (step) {
            step.buttons()[1].enable(true);
            step.buttons()[1].wrapper.addClass('k-button-solid-primary');
        }
    }

    disableNextButton(step) {
        if (step) {
            step.buttons()[1].enable(false);
            step.buttons()[1].wrapper.removeClass('k-button-solid-primary');
        }
    }

    getMicDeviceId(){
        return micDeviceId;
    }
    getSpeakerDeviceId(){
        return speakerDeviceId;
    }
    getCameraDeviceId(){
        return cameraDeviceId;
    }

    // async checkUploadSpeedWithAPI(){

    //     let endTime = 0;
    //     let speedInMbps ;
    //     let fileSizeInKilobytes = 500;
    //     let numberOfFiles = 5;
    //     let testFiles = [];
    //     for(let i = 0; i < numberOfFiles; i++) {
    //         testFiles.push(await this.generate_random_data(fileSizeInKilobytes).text());
    //     }
    //     let totalSizeInBytes = testFiles.reduce((accumulator, currentValue) => {
    //         return accumulator + currentValue.length;
    //       }, 0);
    //     let totalTime = 0;
    //     for(let i=0 ; i < testFiles.length ; i++) {
    //         let isError = false;
    //         let startTime = (new Date).getTime();
    //         let endTime = await this.checkUploadSpeedByAjaxPost(testFiles[i]).catch((error) => {
    //             if (error && error.status == 0) {
    //                 // possibly no network connection
    //                 isError= true;
    //             } else {
    //                 //should we fail upload speed system check on this error ?
    //                 isError= true;
    //             }
    //         });
    //         totalTime += (endTime - startTime) / 1000;
    //         if (isError) {
    //             return 0;
    //         }
    //     }
    //     endTime =  (new Date).getTime();
    //     speedInMbps = Number(this.calculateSpeed(totalSizeInBytes, totalTime));
    //     return speedInMbps;
    // }

    // checkUploadSpeedByAjaxPost(randomText) {
    //     return new Promise((resolve, reject) => {
    //         $.ajax({
    //             url: uploadTestAPIUrl,
    //             type: "POST",
    //             crossDomain: true,
    //             cache: false,
    //             data: randomText,
    //             success: function (data, status, xhr) {
    //                 resolve((new Date).getTime());
    //             },
    //             error: function (xhr, status, error) {
    //                 if (xhr.status == 200) {
    //                     resolve({"time": (new Date).getTime()});
    //                 } else if (xhr.status == 0) {
    //                     reject({"status": 0});
    //                 } else {
    //                     reject(error)
    //                 }
    //             },
    //         });
    //     });
    // }
    
    generate_random_data(size) {
        const blocks = Array.from(
            {length: 1},
            () => Uint8Array.from(
                {length: 1024 * size},
                () => Math.floor(Math.random() * 128)
            )
        );
        return new Blob(blocks, {type: 'application/octet-stream'});
    };

    buildRTPSystemCheckError(error) {
        let code = rtp_i18next.t(`errorMessages:${error}.code`);
        let message = rtp_i18next.t(`errorMessages:${error}.message`);
        return {failureCode:code, failureMsg:message};
    }

    cleanupController(){
        this.stopSpeakerAudioPlaying();
        this.RTPaaSStopVideo();
        exitDialog.data("kendoDialog").close();
        $('#WizardMainDiv-rtpsys') &&  $('#WizardMainDiv-rtpsys').remove();
        $('#welcomeMainDiv') && $('#welcomeMainDiv').remove();
    }

}
